import { render, staticRenderFns } from "./UserIdentityForm.vue?vue&type=template&id=12145704&"
import script from "./UserIdentityForm.vue?vue&type=script&lang=js&"
export * from "./UserIdentityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports